import { BasicCommand } from "../../../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../../../common/services/cqs/IPrimaryKey";

export class InitiateArbetsorderViol3SynchronizationCommand extends BasicCommand<InitiateArbetsorderViol3SynchronizationCommand> {
    get primaryKey(): IPrimaryKey<InitiateArbetsorderViol3SynchronizationCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    checkAddIntressent: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "InitiateArbetsorderViol3SynchronizationCommand";
    constructor(init: (instance: InitiateArbetsorderViol3SynchronizationCommand) => void) {
        super(InitiateArbetsorderViol3SynchronizationCommand.$type, InitiateArbetsorderViol3SynchronizationCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
